export class DrugToFoodAlcoholInteraction {
  public selectedIngredientId: number;
  public selectedIngredientName: string;
  public foodAlcoholId: number;
  public foodAlcoholNameBG: string;
  public foodAlcoholNameEN: string;
  public foodAlcoholName: string;
  public interactionTypeId: number;
  public consumerDecscription: string;
  public professionalDecscription: string;
}